import {AfterContentInit, Directive, ElementRef, inject} from '@angular/core';

@Directive({
  selector: '[pasLiCounter]',
  standalone: true
})
export class LiCounterDirective implements AfterContentInit {
  elementRef = inject(ElementRef)

  constructor() {
  }

  ngAfterContentInit(): void {
    this.apply()
  }

  apply(): void {
    const children: HTMLCollection = this.elementRef.nativeElement.children;
    this.elementRef.nativeElement.classList.add('li-counter');


    const isEmpty = Array.from(children).every(el => {
      return (el as HTMLElement).style.display === 'none'
    });
    isEmpty && this.elementRef.nativeElement.classList.add('empty');
  }

}
